import Textarea from './textarea';

export default Textarea;
